/** Public legal pages live on gizmodata.com (Stripe, prospects and procurement need them
 *  outside the sign-in wall); the portal only links to them. */
export const LEGAL_LINKS = {
  terms: 'https://gizmodata.com/terms-of-service',
  privacy: 'https://gizmodata.com/privacy-policy',
  refunds: 'https://gizmodata.com/refund-policy',
} as const;
